import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://eeoibnjsauvapzpwdjva.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVlb2libmpzYXV2YXB6cHdkanZhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzcwNTI2OTcsImV4cCI6MjA5MjYyODY5N30.9mVQNoHAJ-C_1bXXwbr4ltfq6TH_wm0d-CAy1J0fF7g'

export const supabase = createClient(supabaseUrl, supabaseKey)
